import { Select } from 'antd';
import { useEffect } from 'react';
import type { Partner } from '~/types/auth';
import type { LoanFiltersType } from '~/types/loans';
import { filtersKey } from '~/utils/constants';

interface PartnerReferrersSelectProps {
    partners: Partner[];
    filters: LoanFiltersType;
    setFilters: (filters: LoanFiltersType) => void;
}

const PartnerReferrersSelect = ({
    partners = [],
    filters,
    setFilters,
}: PartnerReferrersSelectProps) => {
    const handlePartnerChange = (value: string) => {
        const newFilters = { ...filters, partner: value || '', referrers: [] };
        setFilters(newFilters);
    };

    const handleReferrerChange = (value: string[]) => {
        const newFilters = { ...filters, referrers: value };
        setFilters(newFilters);
    };

    const partnerOptions = partners.map((partner) => ({
        value: partner.partner,
        label: partner.partner,
    }));

    const selectedPartner = partners.find(
        (partner) => partner.partner === filters.partner,
    );

    /* If a partner is selected, show the referrer options */
    const referrerOptions = selectedPartner
        ? selectedPartner.referrers.map((referrer) => ({
              value: referrer,
              label: referrer,
          }))
        : [];

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        if (!filters.partner && partners.length > 0) {
            handlePartnerChange(partners[0].partner);
        }
    }, []);

    return (
        <div className="flex space-x-3">
            <Select
                allowClear
                showSearch
                className="w-1/4"
                placeholder="Select Partner"
                value={filters?.partner || undefined}
                onChange={handlePartnerChange}
                options={partnerOptions}
            />
            {filters?.partner && (
                <Select
                    allowClear
                    showSearch
                    mode="multiple"
                    className="w-3/4"
                    value={filters?.referrers}
                    onChange={handleReferrerChange}
                    placeholder="Select Referrer"
                    options={referrerOptions}
                />
            )}
        </div>
    );
};

export default PartnerReferrersSelect;
